export default "__VITE_ASSET__DWohvZzT__"